import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Constants } from 'app/components/utils/Constants';
import { Log } from 'app/core/logging/log';
import { BoxDetailsAdminModel } from 'app/models/box-details-admin-model';
import { PriceModel } from 'app/models/price-model';
import { ProductModel } from 'app/models/product-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class AdminBoxDetailsModalContent implements OnInit {
  box: BoxDetailsAdminModel | null = null;
  priceLocker: PriceModel[] = [];
  products: ProductModel[] = [];
  isNew = true;
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {
      box: BoxDetailsAdminModel | null,
      products: ProductModel[],
      priceLocker: PriceModel[]
    },
    public dialogRef: MatDialogRef<BoxDetailsAdminModel>,
    private restService: RestService,
    public appService: AppService
  ) { }

  ngOnInit(): void {
    this.products = this.data?.products ?? [];
    this.priceLocker = this.data?.priceLocker ?? [];
    this.box = this.data?.box ?? null;
    this.isNew = this.box == null;
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group({
      id: [this.box?.id ?? null],
      lockerNumber: [this.box?.lockerNumber ?? null, Validators.required],
      productId: [this.box?.productId ?? null, Validators.required],
      board: [this.box?.board ?? null, Validators.required],
      box: [this.box?.box ?? null, Validators.required],
      password: [this.box?.password ?? '', Validators.minLength(4)],
      doorBox: [this.box?.doorBox ?? 'OPEN', Validators.required],
      priority: [this.box?.priority ?? null, Validators.required],
      channel: [this.box?.channel ?? false, Validators.required],
      enabled: [this.box?.enabled ?? true, Validators.required],
      createdAt: [this.box?.createdAt ?? null],
      updatedAt: [this.box?.updatedAt ?? null],
    });
  }

  confirm() {
    Log.debug('confirm', { box: this.box });
    if (this.isNew) {
      this.postLockers(this.form.value);
    } else {
      this.putLockers(this.form.value);
    }
  }

  postLockers(box: BoxDetailsAdminModel) {
    if (!confirm("Esta seguro de realizar la acciÃ³n?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.postLockers(box).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({ updated: true });
    });
  }

  putLockers(box: BoxDetailsAdminModel) {
    Log.debug('putLockers send', { box });
    if (!confirm("Esta seguro de realizar la acciÃ³n?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.putLockers(box).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({ updated: true });
    });
  }

  deleteLocker() {
    if (!this.box?.id) {
      return;
    }
    Log.debug('deleteLocker send', { box: this.box });
    if (!confirm("Esta seguro de realizar la acciÃ³n?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.deteleLocker(this.box.id).subscribe(result => {
      this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      this.dialogRef.close({ updated: true });
    });
  }

  close() {
    this.dialogRef.close({ updated: false });
  }

  openManual() {
    if (!this.box?.lockerNumber) {
      return;
    }
    if (!confirm("Esta seguro de realizar la acciÃ³n?")) {
      return;
    }
    const lockerNumber = this.box.lockerNumber;
    this.restService.lockerOpenManual(lockerNumber).subscribe(result => {
      Log.debug('lockerOpenManual', result);
      if (result) {
        this.appService.showSuccessToast(Constants.MSG_SUCCESS);
      } else {
        this.appService.showDangerToast(Constants.MSG_DANGER);
      }
    });
  }
}
